import SalesAnalyticsDashboard from "./sales-analytics";

export default function SalesRepresentativeDashboard() {
  return <SalesAnalyticsDashboard />;
}
